export enum ProgrammaticAdviceRecoLevel {
  BASIC = 'basic',
  RECOMMENDED = 'recommended',
  STANDARD = 'standard',
}

export interface WithProgrammaticAdviceReco {
  programmaticAdviceIds?: Partial<
    Record<ProgrammaticAdviceRecoLevel, Array<number>>
  >;
}

export interface ProgrammaticAdviceRecoProduct {
  articleId: number;
  brand: { id: number; logo?: string; name: string };
  modelId: number;
  price: {
    currency: 'EURO' | 'POUND_STERLING';
    current: number;
    retail: number | null;
  };
  productId: number;
  rating: { average: number; total: number };
  slug: string;
  thumbnail: string;
  title: string;
  totalStock: number;
  deliveryLabel:
    | 'freeDeliveryByMM'
    | 'freeDelivery'
    | 'freeManoExpressDelivery'
    | 'manoExpressDelivery'
    | null;
}

export interface ProgrammaticAdviceRecoState {
  data?: [ProgrammaticAdviceRecoLevel, ProgrammaticAdviceRecoProduct][];
  error?: string;
  fetching: boolean;
  size?: number;
}

export const programmaticAdviceRecoInitialState: ProgrammaticAdviceRecoState = {
  fetching: false,
};
